// Webchat appearance / branding (Slice 6b) — the small, tenant-authored config
// that skins a deployed widget. Stored on `channel_endpoint.appearance` (jsonb,
// a partial), returned by the connect response, and applied by the widget as
// CSS variables on its shadow root (the donor's `:root → :host` pattern).
//
// This module is the single source of truth for the shape + defaults, shared by
// the callcenter connect handler (server) and the widget bundle (client) so
// neither drifts. Pure data + a merge accessor — no I/O, no framework.
import { z } from 'zod';
export const APPEARANCE_DEFAULTS = {
    primaryColor: '#0c8f80',
    position: 'bottom-right',
    headerTitle: 'Chat',
    greeting: '',
    theme: 'light',
};
/** Validation schema for a STORED appearance — every field optional (a partial
 *  over the defaults). Used by the endpoint CRUD route to reject junk. */
export const AppearanceSchema = z
    .object({
    primaryColor: z
        .string()
        .regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, 'primaryColor must be a hex colour')
        .optional(),
    position: z.enum(['bottom-right', 'bottom-left']).optional(),
    headerTitle: z.string().max(60).optional(),
    greeting: z.string().max(280).optional(),
    theme: z.enum(['light', 'dark', 'auto']).optional(),
})
    .strict();
/** Merge a stored partial (or anything, defensively) over the defaults →
 *  a complete, safe-to-render appearance. Unknown/extra keys are dropped. */
export function mergeAppearance(partial) {
    const p = (partial && typeof partial === 'object' ? partial : {});
    const pick = (k) => {
        const v = p[k];
        return typeof v === typeof APPEARANCE_DEFAULTS[k] && v !== '' ? v : undefined;
    };
    return {
        primaryColor: pick('primaryColor') ?? APPEARANCE_DEFAULTS.primaryColor,
        position: pick('position') ?? APPEARANCE_DEFAULTS.position,
        headerTitle: pick('headerTitle') ?? APPEARANCE_DEFAULTS.headerTitle,
        greeting: pick('greeting') ?? APPEARANCE_DEFAULTS.greeting,
        theme: pick('theme') ?? APPEARANCE_DEFAULTS.theme,
    };
}
//# sourceMappingURL=appearance.js.map